import { Card, Col, Row, Image, Button, Upload as UploadAntd, Form, message, Modal, Table, Input, DatePicker, Select } from "antd";
import React, { useEffect, useState, useForm } from "react";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import UploadIcon from "../assets/images/upload-icon.svg";
import ModalDeleteIcon from "../assets/images/delete-icon.svg";
import useRequest from "../hooks/useRequest";
import apiPath from "../constants/apiPath";
import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from "@aws-sdk/lib-storage";
import FormItem from "antd/es/form/FormItem";
import ViewTableIcon from "../assets/images/view-table-icon.svg";
import EditTableIcon from "../assets/images/edit-icon-table.svg";
import DeleteTableIcon from "../assets/images/delete-table-icon.svg";
import { ShowToast, Severty } from "../helper/toast";
import { PlusCircleOutlined, PlusOutlined, PauseOutlined, PlayCircleOutlined, ExclamationCircleOutlined, UploadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from 'dayjs/plugin/localeData';
import { useWatch } from "antd/lib/form/Form";
import { template } from "lodash";
import SingleImageUpload from "../components/SingleImageUpload";
import EmojiPicker from "emoji-picker-react";
const { TextArea } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { confirm } = Modal;


dayjs.extend(weekday);
dayjs.extend(localeData);


const s3Config = {
  region: 'us-east-1',
  credentials: {
    accessKeyId: "IJTXH751MBXUWMTWM0SF",
    secretAccessKey: "lfTPRJ2PqAxsp3poTW9YlHktgaL1cFkLup8LidW9",
  },
  endpoint: "https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080",
  forcePathStyle: true,
  requestChecksumCalculation: "WHEN_REQUIRED",
  responseChecksumValidation: "WHEN_REQUIRED",
  maxAttempts: 3,
  retryMode: 'adaptive',
};
const s3Client = new S3Client(s3Config);
const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

const VideoFileType = ["video/mp4", "video/mov"];
const FileType = ["image/png", "image/jpg", "image/jpeg"];

function ScheduleMessage() {
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [selectedContent, setSelectedContent] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [contactList, setContactList] = useState([]);
  const [templateList, setTemplateList] = useState([]);
  const [whatsappDevices, setWhatsappDevices] = useState([]);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const messageType = useWatch("message_type", form);
  const { request } = useRequest();
  const [image, setImage] = useState();
  const [file, setFile] = useState([]);
  const [imageUrl, setImageUrl] = useState('');
  const [uploadLoading, setUploadLoading] = useState(false);

  const handleImage = (data) => {
    data.length > 0 ? setImage(data[0].url) : setImage([]);
  };



  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const fetchContent = () => {
    setLoading(true);
    request({
      url: apiPath.getSchedule,
      method: "GET",
      onSuccess: (data) => {
        if (data.status) {
          setDataSource(data.data.data)
        } else {
          message.error(data.message || "Failed to fetch content");
        }
        setLoading(false);
      },
      onError: (error) => {
        message.error(error?.message || "An error occurred while fetching content");
        setLoading(false);
      },
    });
  };



  useEffect(() => {
    fetchContactList()
    fetchTemplateList()
    fetchWhatsappDevices()
    fetchContent();
  }, []);

  // Update form when edit modal opens and devices are available
  useEffect(() => {
    if (editOpen && selectedContent && whatsappDevices.length > 0) {
      console.log("Updating form with selected content:", selectedContent);
      console.log("Available devices:", whatsappDevices);

      // Check if the device ID exists in available devices
      const deviceId = selectedContent.deviceId || selectedContent.whatsapp_device;
      const deviceExists = whatsappDevices.find(device => device._id === deviceId);
      console.log("Device ID:", deviceId);
      console.log("Device exists:", deviceExists);

      if (deviceExists) {
        form1.setFieldsValue({
          title: selectedContent.title,
          message_type: selectedContent.message_type,
          message: selectedContent.message,
          max_hours: selectedContent.max_hours,
          contacts: selectedContent.contacts,
          whatsapp_device: deviceId,
          schedule_range: dayjs(selectedContent.schedule_range),
          image: selectedContent.image,
          delay_message_minimum: selectedContent.delay_message_minimum,
          delay_message_maximum: selectedContent.delay_message_maximum,
        });
      } else {
        console.warn("Device not found in available devices list");
        // Still set other fields even if device is not found
        form1.setFieldsValue({
          title: selectedContent.title,
          message_type: selectedContent.message_type,
          message: selectedContent.message,
          max_hours: selectedContent.max_hours,
          contacts: selectedContent.contacts,
          schedule_range: dayjs(selectedContent.schedule_range),
          image: selectedContent.image,
          delay_message_minimum: selectedContent.delay_message_minimum,
          delay_message_maximum: selectedContent.delay_message_maximum,
        });
      }
    }
  }, [editOpen, selectedContent, whatsappDevices]);

  const handleSubmit = (values) => {
    // Log the values being submitted for debugging
    console.log('Form values:', values);
    console.log('Image state:', image);
    console.log('Image URL to be sent:', image);

    const payload = {
      ...values,
      schedule_range_timestamp: new Date(values.schedule_range).getTime(),
      image: image || null, // This will be the S3 bucket URL
    };

    console.log('Final payload with image URL:', payload);

    request({
      url: apiPath.createScheduleMessage,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        if (data.status) {
          handleOk();
          ShowToast("Data add successfully!", Severty.SUCCESS);
          fetchContent();
          clearImageState(); // Use the clear function
          form.resetFields();
        } else {
          message.error(data.message || "Failed to create schedule");
        }
      },
      onError: (error) => {
        message.error(error?.message || "An error occurred while creating schedule");
      },
    });
  };



  const handleEditSubmit = (values) => {
    // Log the values being submitted for debugging
    console.log('Edit form values:', values);
    console.log('Edit image state:', image);
    console.log('Edit image URL to be sent:', image);

    const payload = {
      ...values,
      schedule_range_timestamp: new Date(values.schedule_range).getTime(),
      image: image || null, // This will be the S3 bucket URL
    };

    console.log('Edit final payload with image URL:', payload);

    request({
      url: `${apiPath.UpdateScheduleMessage}/${selectedContent._id}`,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        if (data.status) {
          form1.resetFields(); // Reset the edit form fields
          clearImageState(); // Use the clear function
          setEditOpen(false);
          ShowToast("Data updated successfully!", Severty.SUCCESS);
          fetchContent();
        } else {
          message.error(data.message || "Failed to update schedule");
        }
      },
      onError: (error) => {
        message.error(error?.message || "An error occurred while updating schedule");
      },
    });
  };



  const handleEditContent = (record) => {
    if (!record || !record._id) {
      message.error("Invalid  record");
      return;
    }

    console.log("Edit record:", record);
    console.log("WhatsApp device ID:", record.deviceId || record.whatsapp_device);
    console.log("Available devices:", whatsappDevices);

    setSelectedContent(record);
    setImage(record.image);

    // Clear any existing file state when editing
    setFile([]);
    setImageUrl('');

    // Set form values after a small delay to ensure devices are loaded
    setTimeout(() => {
      const deviceId = record.deviceId || record.whatsapp_device;
      form1.setFieldsValue({
        title: record.title,
        message_type: record.message_type,
        message: record.message,
        max_hours: record.max_hours,
        contacts: record.contacts,
        whatsapp_device: deviceId, // Keep as whatsapp_device for edit form
        schedule_range: dayjs(record.schedule_range),
        image: record.image,
        // delay_message: record.delay_message,
        delay_message_minimum: record.delay_message_minimum, // Update to match new name
        delay_message_maximum: record.delay_message_maximum,
      });

      // Log the form values to verify
      console.log("Form values set:", record, {
        whatsapp_device: deviceId,
        title: record.title,
        message: record.message
      });
    }, 100);

    setEditOpen(true);
  }


  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    form.resetFields();
    clearImageState();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    clearImageState();
  };

  const showFactoryData = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want to {record.is_active ? "Pause" : "Resume"} this schedule message </Button>,
        onOk() {
          handleToggleActiveStatus(record)
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const handleToggleActiveStatus = (record) => {
    request({
      url: `${apiPath.UpdateScheduleMessageStatus}/${record._id}`,
      method: "PUT",
      data: {
        is_active: !record.is_active,
      },
      onSuccess: (data) => {
        if (data.status) {
          fetchContent();
        } else {
          message.error(data.message || "Failed to update schedule");
        }
      },
      onError: (error) => {
        message.error(error?.message || "An error occurred while updating schedule");
      },
    });
  }

  const columns = [
    {
      title: "S.NO",
      dataIndex: "sno",
      key: "sno",
      width: 80,
      render: (text, record, index) => (
        <span className="sno">
          {((pagination.current - 1) * pagination.pageSize + index + 1)
            .toString()
            .padStart(2, "0")}
        </span>
      ),
    },

    {
      title: "Message Title",
      dataIndex: "title",
      key: "title",
      render: (title) => (
        <div>
          <p className="description">{title}</p>
        </div>
      ),
    },
    {
      title: "Message Type",
      dataIndex: "message_type",
      key: "message_type",
      render: (message_type) => (
        <div>
          <p className="description">{message_type}</p>
        </div>
      ),
    },
    {
      title: "ACTION'S",
      key: "actions",
      width: 150,
      render: (record) => (
        <div className="actions">
          <Button
            className="edit-btn-table"
            icon={<img src={EditTableIcon} alt="Edit" />}
            onClick={() => handleEditContent(record)}
          />
          <Button
            className="edit-btn-table"
            icon={record.is_active ? <PlayCircleOutlined /> : <PauseOutlined />}
            onClick={() => showFactoryData(record)}
          />

        </div>
      ),
    },
  ];


  const fetchContactList = () => {
    request({
      url: `/common/contact-list`,
      method: "GET",
      onSuccess: (data) => {
        setContactList(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const fetchTemplateList = () => {
    request({
      url: `/common/template-list`,
      method: "GET",
      onSuccess: (data) => {
        setTemplateList(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchWhatsappDevices = () => {
    request({
      url: apiPath.getdevice,
      method: "GET",
      onSuccess: (data) => {
        if (data.status) {
          console.log("WhatsApp devices fetched:", data.data.data);
          setWhatsappDevices(data.data.data || []);
        } else {
          ShowToast(data.message || "Failed to fetch WhatsApp devices", Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error?.message || "Failed to fetch WhatsApp devices", Severty.ERROR);
      },
    });
  };

  const renderDeviceOption = (device) => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontWeight: 'bold' }}>{device.businessName || 'Unknown'}</span>
          <span style={{
            fontSize: '12px',
            color: device.is_status ? '#52c41a' : '#ff4d4f',
            fontWeight: 'bold'
          }}>
            {device.is_status ? '● Active' : '○ Inactive'}
          </span>
        </div>
        <div style={{ fontSize: '12px', color: '#666' }}>
          Phone: {device.deviceNumber}
        </div>
      </div>
    );
  };

  const handleDeviceSelect = (value) => {
    console.log("Selected device:", value);
    const selectedDevice = whatsappDevices.find(device => device._id === value);
    console.log("Selected device details:", selectedDevice);
  };

  const onEmojiClick = (emojiObject) => {
    const currentValue = form.getFieldValue("message") || "";
    form.setFieldsValue({
      message: currentValue + emojiObject.emoji,
    });
  };

  // Remove uploaded image
  const removeImage = () => {
    if (file.length > 0 && file[0].url) {
      // Just clear the image state (no need to modify message text)
      setFile([]);
      setImage(null);
      setImageUrl('');
      message.success("Image removed successfully!");
    }
  };

  // Remove existing image in edit mode
  const removeExistingImage = () => {
    if (selectedContent?.image) {
      // Just clear the image state (no need to modify message text)
      setSelectedContent({ ...selectedContent, image: null });
      setImage(null);
      message.success("Existing image removed successfully!");
    }
  };

  // Clear image state when form is reset
  const clearImageState = () => {
    setImage(null);
    setImageUrl('');
    setFile([]);
  };
  const beforeUpload = (file) => {
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      // ShowToast.error(`Image must be smaller than 5 MB!`)
      return false;
    }
    return true;
  };
  const uploadFileToS3 = async (file, bucketName) => {
    const key = "realState/admin" + file.name;
    const params = {
      Bucket: bucketName,
      Key: key,
      Body: file,
    };

    const upload = new Upload({
      client: s3Client,
      params: params,
    });

    try {
      const data = await upload.done();
      setLoading(false);
      console.log(data);
      return data;
    } catch (err) {
      throw err;
    }
  };

  const handleChange = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg") && !file.type.includes("gif");
    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }

    const isValidSize = beforeUpload(file);

    if (!isValidSize) {
      return ShowToast(
        "Image must be smaller than 5 MB!" + file.size / 1024 / 1024,
        Severty.ERROR
      );
    }

    setUploadLoading(true);
    setFile([{ ...file, status: 'uploading' }]);

    try {
      const data = await uploadFileToS3(file, "invent-colab-obj-bucket");

      if (data?.Location) {
        const fileData = {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: data.Location,
          thumbUrl: data.Location,
        };

        setFile([fileData]);

        // Store the S3 URL in the image state for API submission
        setImage(data.Location);
        setImageUrl(data.Location);

        message.success("Image uploaded successfully!");
        console.log("S3 Upload successful:", data);
      } else {
        message.error("Upload failed. Please try again.");
        setFile([]);
      }
    } catch (err) {
      console.error("Upload Error:", err);
      message.error("Error uploading file.");
      setFile([]);
    } finally {
      setUploadLoading(false);
    }
  };

  return (
    <>
      <div className="page-top-space home-card layout-content">
        <div className="mb-24">
          <Row gutter={[24, 0]}>
            <Col xs={24} sm={24} md={24}>
              <Card bordered={false} className="card-main">
                <div className="upload-contant-card">
                  <div className="upload-card-header">
                    <div className="dashbord-headding-cont">
                      <h6>Schedule Message List</h6>
                      <Button
                        type="primary"
                        className="fill-btn"
                        onClick={showModal}
                      >
                        <PlusOutlined /> Add Schedule Message
                      </Button>
                    </div>

                    {/* <p>Lorem ipsum dolor sit amet consectetur. Duis cursus amet massa</p> */}
                    <div className="table-responsive">
                      <Table
                        dataSource={dataSource}
                        columns={columns}
                        loading={loading}
                        rowKey="id"
                        pagination={pagination}
                        onChange={handleTableChange}
                      />
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <Modal
        title="Add Schedule Message"
        className="tab_modal"
        width={900}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Card bordered={false} className="card-main">
          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Row gutter={16}>
              <Col span={24} md={12}>
                <Form.Item
                  name="deviceId"
                  label="Select WhatsApp Number"
                  rules={[
                    { required: true, message: "Please select a WhatsApp number" },
                  ]}
                >
                  <Select
                    placeholder="Select WhatsApp Number"
                    showSearch
                    onChange={handleDeviceSelect}
                    filterOption={(input, option) => {
                      const device = whatsappDevices.find(d => d._id === option.value);
                      if (!device) return false;
                      const searchText = `${device.businessName} ${device.deviceNumber}`.toLowerCase();
                      return searchText.includes(input.toLowerCase());
                    }}
                  >
                    {whatsappDevices.map((device) => (
                      <Option key={device._id} value={device._id}>
                        {device.businessName || 'Unknown'} - {device.deviceNumber} ({device.is_status ? 'Active' : 'Inactive'})
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24} md={12}>
                <Form.Item
                  name="title"
                  label="Title"
                  rules={[{ required: true, message: "Please enter a title" }]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={24} md={12}>
                <Form.Item
                  name="message_type"
                  label="Message Type"
                  initialValue="Plain Text"
                >
                  <Select defaultValue="Plain Text">
                    <Option value="Plain Text">Plain Text</Option>
                    <Option value="Template">Template</Option>
                  </Select>
                </Form.Item>
              </Col>

              {messageType === "Plain Text" ? (
                <Col span={24}>
                  <Form.Item
                    className="emoji_iconjj"
                    name="message"
                    label={
                      <>
                        {"Message {first_name} {last_name}"}
                        <button
                          type="button"
                          className="emoji-button-new"
                          onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                        >
                          😀
                        </button>
                      </>
                    }
                    rules={[
                      { required: true, message: "Please enter a message" },
                    ]}
                  >

                    <TextArea
                      rows={4}
                      value={form.getFieldValue("message")}
                      onChange={(e) => form.setFieldsValue({ message: e.target.value })}
                    />
                    <div style={{ marginTop: 8 }}>
                      <UploadAntd
                        accept="image/*"
                        showUploadList={false}
                        beforeUpload={beforeUpload}
                        customRequest={handleChange}
                        fileList={file}
                      >
                        <Button
                          icon={<UploadOutlined />}
                          loading={uploadLoading}
                        >
                          {uploadLoading ? 'Uploading...' : 'Upload Image (Optional)'}
                        </Button>
                      </UploadAntd>
                      <div style={{ marginTop: 4, fontSize: '12px', color: '#999' }}>
                        Images are optional and stored separately from your message text. Upload PNG, JPG, or JPEG files up to 5MB.
                      </div>

                      {/* Display uploaded images */}
                      {file.length > 0 && file[0].status === 'done' && (
                        <div style={{ marginTop: 8 }}>
                          <div style={{ position: 'relative', display: 'inline-block' }}>
                            <Image
                              width={120}
                              src={file[0].url}
                              alt="Uploaded"
                              style={{ borderRadius: 4 }}
                            />
                            <Button
                              type="text"
                              size="small"
                              danger
                              style={{
                                position: 'absolute',
                                top: -8,
                                right: -8,
                                minWidth: 'auto',
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                padding: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                              onClick={removeImage}
                              title="Remove image"
                            >
                              ×
                            </Button>
                          </div>
                          <div style={{ marginTop: 4, fontSize: '12px', color: '#666' }}>
                            Image uploaded successfully
                          </div>
                          <Button
                            type="link"
                            size="small"
                            danger
                            onClick={removeImage}
                            style={{ padding: 0, marginTop: 4 }}
                          >
                            Remove Image
                          </Button>
                        </div>
                      )}
                    </div>
                  </Form.Item>
                  {showEmojiPicker && (
                    <div className="emoji-picker-new">
                      <EmojiPicker onEmojiClick={onEmojiClick} />
                    </div>
                  )}
                </Col>
              ) : (
                <Col span={24}>
                  <Form.Item
                    label="Select Template List"
                    name="template"
                    className="main-new-location-newh"
                  >
                    <Select
                      placeholder="Select Template List"
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {templateList.map((proj) => (
                        <Option key={proj._id} value={proj._id}>
                          {proj.title}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}

              <Col span={24}>
                <Form.Item
                  label="Select Contact List"
                  name="contacts"
                  className="main-new-location-newh"
                >
                  <Select
                    placeholder="Select Contact List"
                    mode="multiple"
                    showSearch
                    optionFilterProp="children"
                  // filterOption={(input, option) =>
                  //   option?.children?.toLowerCase()
                  //     ?.includes(input?.toLowerCase())
                  // }
                  >
                    {contactList.map((proj) => (
                      <Option key={proj._id} value={proj._id}>
                        {proj.title} {proj.totalContact}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>


              <Col span={24} md={12}>
                <Form.Item
                  name="schedule_range"
                  label="Schedule Date & Time"
                  rules={[
                    { required: true, message: "Please select date and time" },
                  ]}
                >
                  <DatePicker
                    showTime
                    format="YYYY-MM-DD HH:mm"
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>

              {/* <Col span={24} md={12}>
                <Form.Item
                  name="max_hours"
                  label="Max Hours"
                  rules={[
                    { required: true, message: "Please enter max hours" },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
              </Col> */}

              {/* <Col span={24}> */}
              {/* <Form.Item
                  label="Upload Image"
                  name="image"
                >
                  <SingleImageUpload
                    value={image}
                    fileType={FileType}
                    imageType={"schedule_message"}
                    btnName={"Image"}
                    onChange={(data) => handleImage(data)}
                    isDimension={false}
                  />
                  {image && (
                    <div className="mt-2">
                      <Image width={120} src={image} />
                    </div>
                  )}
                </Form.Item> */}


              {/* <Form.Item
                  name="delay_message"
                  label="Delay Between Messages ( In Minutes )"
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  rules={[
                    // { required: true, message: 'Please enter the Delay ' },
                  ]}
                >
                  <Input
                    placeholder="Enter minutes in numbers only"
                    formatter={value => `${value}`.replace(/[^\d.]/g, '')}
                    parser={value => value.replace(/[^\d.]/g, '')}
                  />
                </Form.Item> */}


              {/* </Col> */}


              <Col span={24}>
                <h5>Delay Between Messages ( In Minutes )</h5>
              </Col>
              <Col span={24} md={12}>

                <Form.Item
                  name="delay_message_minimum"
                  label="Minimum delay ( In seconds )"
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  rules={[
                    // { required: true, message: 'Please enter the Delay ' },
                  ]}
                >
                  <Input
                    placeholder="Enter minutes in numbers only"
                    formatter={value => `${value}`.replace(/[^\d.]/g, '')}
                    parser={value => value.replace(/[^\d.]/g, '')}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="delay_message_maximum"
                  label="Maximum delay ( In Seconds )"
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  rules={[
                    // { required: true, message: 'Please enter the Delay ' },
                  ]}
                >
                  <Input
                    placeholder="Enter minutes in numbers only"
                    formatter={value => `${value}`.replace(/[^\d.]/g, '')}
                    parser={value => value.replace(/[^\d.]/g, '')}
                  />
                </Form.Item>


              </Col>


              <Col span={24}>
                <Form.Item className="text-right">
                  <Button type="primary" className="fill-btn" htmlType="submit">
                    Create Schedule
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      </Modal >

      {/* Edit Question Modal */}
      <Modal
        title="Edit Schedule Message"
        className="tab_modal"
        width={900}
        open={editOpen}
        onCancel={() => {
          setEditOpen(false);
          form1.resetFields();
          clearImageState();
        }
        }
        footer={[false]}
      >
        <Card bordered={false} className="card-main">
          <Form form={form1} layout="vertical" onFinish={handleEditSubmit}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="whatsapp_device"
                  label="Select WhatsApp Number"
                  rules={[
                    { required: true, message: "Please select a WhatsApp number" },
                  ]}
                >
                  <Select
                    placeholder="Select WhatsApp Number"
                    showSearch
                    onChange={handleDeviceSelect}
                    filterOption={(input, option) => {
                      const device = whatsappDevices.find(d => d._id === option.value);
                      if (!device) return false;
                      const searchText = `${device.businessName} ${device.deviceNumber}`.toLowerCase();
                      return searchText.includes(input.toLowerCase());
                    }}
                  >
                    {whatsappDevices.map((device) => (
                      <Option key={device._id} value={device._id}>
                        {device.businessName || 'Unknown'} - {device.deviceNumber} ({device.is_status ? 'Active' : 'Inactive'})
                      </Option>
                    ))}

                  </Select>
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="title"
                  label="Title"
                  rules={[{ required: true, message: "Please enter a title" }]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="message_type"
                  label="Message Type"
                  initialValue="Plain Text"
                >
                  <Select defaultValue="Plain Text">
                    <Option value="Plain Text">Plain Text</Option>
                    <Option value="Template">Template</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  name="message"
                  label="Message {first_name} {last_name}"
                  rules={[
                    { required: true, message: "Please enter a message" },
                  ]}
                >
                  <TextArea rows={4} />

                  {/* Display existing uploaded image in edit mode */}
                  {selectedContent?.image && (
                    <div style={{ marginTop: 8 }}>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <Image
                          width={120}
                          src={selectedContent.image}
                          alt="Uploaded"
                          style={{ borderRadius: 4 }}
                        />
                        <Button
                          type="text"
                          size="small"
                          danger
                          style={{
                            position: 'absolute',
                            top: -8,
                            right: -8,
                            minWidth: 'auto',
                            width: '20px',
                            height: '20px',
                            borderRadius: '50%',
                            padding: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                          onClick={removeExistingImage}
                          title="Remove existing image"
                        >
                          ×
                        </Button>
                      </div>
                      <div style={{ marginTop: 4, fontSize: '12px', color: '#666' }}>
                        Previously uploaded image
                      </div>
                      <Button
                        type="link"
                        size="small"
                        danger
                        onClick={removeExistingImage}
                        style={{ padding: 0, marginTop: 4 }}
                      >
                        Remove Existing Image
                      </Button>
                    </div>
                  )}

                  {/* Upload new image in edit mode */}
                  <div style={{ marginTop: 8 }}>
                    <UploadAntd
                      accept="image/*"
                      showUploadList={false}
                      beforeUpload={beforeUpload}
                      customRequest={handleChange}
                      fileList={file}
                    >
                      <Button
                        icon={<UploadOutlined />}
                        loading={uploadLoading}
                      >
                        {uploadLoading ? 'Uploading...' : 'Upload New Image (Optional)'}
                      </Button>
                    </UploadAntd>
                    <div style={{ marginTop: 4, fontSize: '12px', color: '#999' }}>
                      New images are optional and stored separately from your message text. Upload PNG, JPG, or JPEG files up to 5MB.
                    </div>

                    {/* Display newly uploaded images in edit mode */}
                    {file.length > 0 && file[0].status === 'done' && (
                      <div style={{ marginTop: 8 }}>
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                          <Image
                            width={120}
                            src={file[0].url}
                            alt="Newly Uploaded"
                            style={{ borderRadius: 4 }}
                          />
                          <Button
                            type="text"
                            size="small"
                            danger
                            style={{
                              position: 'absolute',
                              top: -8,
                              right: -8,
                              minWidth: 'auto',
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              padding: 0,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                            onClick={removeImage}
                            title="Remove new image"
                          >
                            ×
                          </Button>
                        </div>
                        <div style={{ marginTop: 4, fontSize: '12px', color: '#666' }}>
                          New image uploaded successfully
                        </div>
                        <Button
                          type="link"
                          size="small"
                          danger
                          onClick={removeImage}
                          style={{ padding: 0, marginTop: 4 }}
                        >
                          Remove New Image
                        </Button>
                      </div>
                    )}
                  </div>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Select Contact List"
                  name="contacts"
                  className="main-new-location-newh"
                >
                  <Select
                    mode="multiple"
                    placeholder="Select Contact List"
                    showSearch
                    optionFilterProp="children"
                  // filterOption={(input, option) =>
                  //   option?.children
                  //     .toLowerCase()
                  //     .includes(input.toLowerCase())
                  // }
                  >
                    {contactList.map((proj) => (
                      <Option key={proj._id} value={proj._id}>
                        {proj.title} {proj.totalContact}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24} md={12}>
                <Form.Item
                  name="schedule_range"
                  label="Schedule Date & Time"
                  rules={[
                    { required: true, message: "Please select date and time" },
                  ]}
                >
                  <DatePicker
                    showTime
                    format="YYYY-MM-DD HH:mm"
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>

              {/* <Col span={12}>
                <Form.Item
                  name="max_hours"
                  label="Max Hours"
                  rules={[
                    { required: true, message: "Please enter max hours" },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
              </Col> */}

              {/* <Col span={24}>
                <Form.Item
                  label="Upload Image"
                  name="image"
                >
                  <SingleImageUpload
                    value={image}
                    fileType={FileType}
                    imageType={"schedule_message"}
                    btnName={"Image"}
                    onChange={(data) => handleImage(data)}
                    isDimension={false}
                  />
                </Form.Item>

              </Col> */}
              <Col span={24}>
                <h5>Delay Between Messages ( In Minutes )</h5>
              </Col>
              <Col span={24} md={12}>

                <Form.Item
                  name="delay_message_minimum"
                  label="Minimum delay ( In seconds )"
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  rules={[
                    // { required: true, message: 'Please enter the Delay ' },
                  ]}
                >
                  <Input
                    placeholder="Enter minutes in numbers only"
                    formatter={value => `${value}`.replace(/[^\d.]/g, '')}
                    parser={value => value.replace(/[^\d.]/g, '')}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>

                <Form.Item
                  name="delay_message_maximum"
                  label="Maximum delay ( In Seconds )"
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  rules={[
                    // { required: true, message: 'Please enter the Delay ' },
                  ]}
                >
                  <Input
                    placeholder="Enter minutes in numbers only"
                    formatter={value => `${value}`.replace(/[^\d.]/g, '')}
                    parser={value => value.replace(/[^\d.]/g, '')}
                  />
                </Form.Item>


              </Col>
              <Col span={24}>
                <Form.Item className="text-right">
                  <Button type="primary" className="fill-btn" htmlType="submit">
                    Update Schedule
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      </Modal >
    </>
  );
}

export default ScheduleMessage;
